import type { RouteRecordRaw } from 'vue-router';
import {
  AccountRouteName,
  AuthRouteName,
} from '@/js/account/app/router/route-names';
import ProfileLayout from '@/js/account/layouts/profile-layout/ProfileLayout.vue';
import CheckYourEmailPage from '@/js/account/pages/auth-check-email/CheckYourEmailPage.vue';
import ForgotPasswordPage from '@/js/account/pages/auth-forgot-password/ForgotPasswordPage.vue';
import LoginPage from '@/js/account/pages/auth-login/LoginPage.vue';
import PasswordChangedSuccessPage from '@/js/account/pages/auth-password-changed/PasswordChangedSuccessPage.vue';
import RegisterPage from '@/js/account/pages/auth-register/RegisterPage.vue';
import ResetPasswordPage from '@/js/account/pages/auth-reset-password/ResetPasswordPage.vue';
import ProfileDashboardPage from '@/js/account/pages/profile-dashboard/ProfileDashboardPage.vue';
import ProfileDownloadsPage from '@/js/account/pages/profile-downloads/ProfileDownloadsPage.vue';
import ProfileLibraryPage from '@/js/account/pages/profile-library/ProfileLibraryPage.vue';
import ProfilePage from '@/js/account/pages/profile-profile/ProfilePage.vue';

export const accountRoutes: RouteRecordRaw[] = [
  {
    path: '/auth',
    children: [
      {
        path: 'login',
        name: AuthRouteName.Login,
        meta: { guest: true, title: 'Login' },
        component: LoginPage,
      },
      {
        path: 'register',
        name: AuthRouteName.Register,
        meta: { guest: true, title: 'Create an Account' },
        component: RegisterPage,
      },
      {
        path: 'verify-email',
        name: AuthRouteName.VerifyEmail,
        meta: { requiresAuth: true, title: 'Check your email' },
        component: CheckYourEmailPage,
      },
      {
        path: 'email-changed',
        name: AuthRouteName.EmailChanged,
        meta: { guest: true, title: 'Check your email' },
        component: CheckYourEmailPage,
      },
      {
        path: 'forgot-password',
        name: AuthRouteName.ForgotPassword,
        meta: { guest: true, title: 'Forgot password' },
        component: ForgotPasswordPage,
      },
      {
        path: 'check-mail',
        name: AuthRouteName.CheckMail,
        meta: { guest: true, title: 'Check your mail' },
        component: CheckYourEmailPage,
      },
      {
        path: 'reset-password',
        name: AuthRouteName.ResetPassword,
        meta: { guest: true, title: 'Reset password' },
        component: ResetPasswordPage,
      },
      {
        path: 'password-changed',
        name: AuthRouteName.PasswordChangedSuccess,
        meta: { guest: true, title: 'Password changed' },
        component: PasswordChangedSuccessPage,
      },
    ],
  },
  {
    path: '/account',
    component: ProfileLayout,
    meta: { requiresVerified: true },
    children: [
      {
        path: '',
        redirect: { name: AccountRouteName.Dashboard },
      },
      {
        path: 'dashboard',
        name: AccountRouteName.Dashboard,
        meta: { requiresVerified: true, title: 'Dashboard' },
        component: ProfileDashboardPage,
      },
      {
        path: 'library',
        name: AccountRouteName.Library,
        meta: { requiresVerified: true, title: 'Library' },
        component: ProfileLibraryPage,
      },
      {
        path: 'library/:id',
        name: AccountRouteName.LibraryDocument,
        meta: { requiresVerified: true, title: 'Document' },
        component: async () => {
          return import('@/js/account/pages/profile-library/LibraryDocumentPage.vue');
        },
      },
      {
        path: 'downloads',
        name: AccountRouteName.Downloads,
        meta: { requiresVerified: true, title: 'Download History' },
        component: ProfileDownloadsPage,
      },
      {
        path: 'admin/documents/new',
        name: AccountRouteName.AdminDocumentCreate,
        meta: { requiresVerified: true, requiresAdmin: true, title: 'Create document' },
        component: async () => {
          return import('@/js/account/pages/admin-document-create/DocumentCreatePage.vue');
        },
      },
      {
        path: 'admin/documents/:id/edit',
        name: AccountRouteName.AdminDocumentEdit,
        meta: { requiresVerified: true, requiresAdmin: true, title: 'Edit document' },
        component: async () => {
          return import('@/js/account/pages/admin-document-edit/DocumentEditPage.vue');
        },
      },
      {
        path: 'profile',
        name: AccountRouteName.Profile,
        meta: { requiresVerified: true, title: 'My Profile' },
        component: ProfilePage,
      },
      {
        path: ':pathMatch(.*)*',
        redirect: { name: AccountRouteName.Dashboard },
      },
    ],
  },
  { path: '/auth', redirect: { name: AuthRouteName.Login } },
  { path: '/auth/:pathMatch(.*)*', redirect: { name: AuthRouteName.Login } },
];
